$(document).ready(function () {
  $(".faq-item").click(function(){
    
    $(this).toggleClass("open-faq");
  })
  $(".shopify_explorer_faq__question").click(function () {
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $(this).next().slideUp();
    } else {
      $(".shopify_explorer_faq__question").removeClass("open");
      $(".shopify_explorer_faq__answer").slideUp();
      $(this).addClass("open");
      $(this).next().slideDown();
    }
  });
  $("div[data-framer-name='Question']").click(function () {
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $(this).next().slideUp();
    } else {
      $("div[data-framer-name='Question']").removeClass("open");
      
      $(this).addClass("open");
      $(this).next().slideDown();
    }
  });


    document.querySelectorAll(".accordion-button").forEach(button => {
        button.addEventListener("click", function () {
            document.querySelectorAll(".accordion-button").forEach(otherButton => {
                if (otherButton !== this) {
                    otherButton.setAttribute("aria-expanded", "false");
                    otherButton.nextElementSibling.style.display = "none";
                }
            });
            
            const content = this.nextElementSibling;
            const isExpanded = this.getAttribute("aria-expanded") === "true";
            
            this.setAttribute("aria-expanded", !isExpanded);
            content.style.display = isExpanded ? "none" : "block";
        });
    });


});
